<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: leftcolumn }">
        <a-form-item label="Used For">
          <a-radio-group
            v-decorator="[
              'used_for',
              { rules: [{ required: true }], initialValue: '0' },
            ]"
            @change="handleUseFor"
            ref="refused_for"
          >
            <a-radio value="0">Item</a-radio>
            <a-radio value="2">Tax</a-radio>
            <a-radio value="3">Shipping</a-radio>
            <a-radio value="4">Etc</a-radio>
            <a-radio value="1">Discount</a-radio>
          </a-radio-group>
        </a-form-item>
        <div v-if="trigered.tax">
        <a-form-item label="Tax Type">
          <a-select
            v-decorator="[
              'type_tax',
              {
                rules: [{ required: true }],
                initialValue: undefined,
              },
            ]"
            @change="taxTypeChange"
            showSearch
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option
                v-for="item in listType_tax"
                :key="item.value"
                :value="item.value"
              >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>
        </div>
        <a-form-item
          label="PO/WO Detil" v-if="trigered.powodtl"
        >
          <a-select
            showSearch
            allowClear
            v-decorator="[
              'powopdtl',
              { rules: [{ required: true }], initialValue: undefined },
            ]"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="handleChangepowoPdtl"
          >
            <a-select-option v-for="item in listPOWO" :key="item.id" :disabled="item.sisa<=0">
              <!-- {{ item.item }} -->
              <div class="elipsdiv">
                <div class="elipsdiv-mouseover-label1" >
                  <template v-if="item.type_tax">
                    <b>[{{ lblTax(item.type_tax) }}]</b>
                  </template>
                  {{ item.item }}
                </div>
                <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">{{
                        formatCurrency(item.currency,parseFloat(item.sisa))
                      }}
                    </b>
                </div>
              </div>
            </a-select-option>
          </a-select>
          <div v-if="dtl_desc.unit_price!=''" class="m-form-description-small">
            <div class="m-display-flex space-between align-middle" slot="header">
              <span><b>Quantity : </b>{{dtl_desc.qty}}</span>
             <span><b>Unit Price : </b>{{formatCurrency(dtl_desc.currency,dtl_desc.unit_price)}}</span>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="Item Name">
          <a-input
            autocomplete="off"
            v-decorator="['nama_item', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="24" v-if="trigered.value.byQty">
          <a-col :span="getScreen ? 24 : 6">
            <a-form-item label="Quantity">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'quantity',
                  { rules: [{ required: true }, { validator: checkMaxValue }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="getScreen ? 24 : 18">
            <a-form-item label="Unit">
              <a-auto-complete
                allowClear
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="['unit', { rules: [{ required: true }] }]"
                :filterOption="handleSatuan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="Value">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkMaxValue }] },
                ]"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row> -->
        <a-row :gutter="24" v-if="trigered.value.byOption">
          <a-col :span="24">
            <a-form-item label="Value">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkMaxValue }] },
                ]"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Note">
          <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="[
              'note',
              { rules: [{ required: false }] },
            ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleNewItem"
            block
            type="primary"
            html-type="submit"
            :loading="newLoading"
            ref="addMainBtn"
            v-decorator="['addMainBtn']"
            >Add</a-button
          >
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: rightcolumn }">
        <a-card class="m-height-full m-display-flex nowrap flex-column">
          <div slot="title">
              <span>Purchase List</span>
          </div>
          <template slot="extra">
              <a-button @click="handleExpand()" v-if="!getScreen">
              <span>{{ labelExpand }}</span>
              </a-button>
          </template>
          <div class="body-flex">
            <a-table
              :columns="columns"
              :dataSource="getCountWeb"
              :pagination="pagination"
              size="small"
              :scroll="{ x: 700 }"
              bordered
            >
            <template slot="nama_item" slot-scope="index, item">
              <b>[{{lblusedfor(item.used_for)}}] 
              <span v-if="item.used_for=='2'">[{{lblTax(item.type_tax)}}]</span>  
              </b> <br/>{{item.nama_item}}<br/>
              <i><small>{{item.note}}</small></i>
            </template>
            <template slot="itemPoWoDtl" slot-scope="index, item">
              <b>{{item.po_wo_nm}}</b>
            </template>
            <template slot="unit_price" slot-scope="index, item">
              {{formatCurrency(informasi.mata_uang,item.value)}}
            </template>
            <template slot="amount" slot-scope="index, item">
              {{formatCurrency(informasi.mata_uang,item.value*(item.quantity ? item.quantity : 1))}}
            </template>
            <template slot="operation" slot-scope="index, item">
              <div class="m-width-full">
              <a-button-group class="m-width-full">
                <a-button
                class="m-width-full"
                  size="small"
                  type="primary"
                  @click="handleToEdit(item)"
                  :disabled="totalDiscList>0  && item.used_for!='1'"
                >
                  <a-icon type="edit" />
                </a-button>
                <a-button type="danger"
                class="m-width-full"
                  size="small"
                  @click="handleToDelete(item)"
                  :disabled="totalDiscList>0 && item.used_for!='1'"
                  >
                  <a-icon type="close"/>
                </a-button>
              </a-button-group>
              </div>
            </template>
            </a-table>
            <div class="m-price-total">
              <a-row type="flex">
                <a-col :span="7" :order="1" class="m-text-align left">Sub Total</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="10"
                  :order="3"
                  class="m-text-align left"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="totalPrice"
                  />
                </a-col>
              </a-row>
              <a-row type="flex">
                <a-col :span="7" :order="1" class="m-text-align left">Discount</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="10"
                  :order="3"
                  class="m-text-align left"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="totalDiscList"
                  />
                </a-col>
              </a-row>
              <a-row type="flex">
                <a-col :span="7" :order="1" class="m-text-align left">DPP</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="10"
                  :order="3"
                  class="m-text-align left"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="totalPrice-totalDiscList"
                  />
                </a-col>
              </a-row>
              <a-row type="flex">
                <a-col :span="7" :order="1" class="m-text-align left">Tax</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="10"
                  :order="3"
                  class="m-text-align left"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="nilaiPajak"
                  />
                </a-col>
              </a-row>
              <a-divider class="margin-medium" />
              <a-statistic
                title="Total"
                :value="formatCurrency(mata_uang, grandTotal.all)"
                class="margin-top m-text-align right"
              />
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      v-model="editModal"
      v-if="editModal"
      @ok="handleEditModal"
      @cancel="handleClose"
      :maskClosable="false"
      :footer="null"
    >
      <span slot="title">
        <a-icon type="form" class="margin-right-small" />Change
      </span>

      <a-form :form="modalForm">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-form-item label="Used For">
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'used_for',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.used_for,
                  },
                ]"
                @change="handleUseFor"
              >
                <a-radio value="0">Item</a-radio>
                <a-radio value="2">Tax</a-radio>
                <a-radio value="3">Shipping</a-radio>
                <a-radio value="4">Etc</a-radio>
                <a-radio value="1">Discount</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Tax Type" v-if="trigered.tax">
          <a-select
            v-decorator="[
              'type_tax',
              {
                rules: [{ required: true }],
                initialValue: editData.type_tax
              },
            ]"
            @change="taxTypeChange"
            showSearch
            option-filter-prop="children"
            :filter-option="filterOption"
            disabled
          >
            <a-select-option
                v-for="item in listType_tax"
                :key="item.value"
                :value="item.value"
              >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="PO/WO Detil" v-if="trigered.powodtl"
        >
          <a-select
            showSearch
            allowClear
            v-decorator="[
              'powopdtl',
              { rules: [{ required: true }], initialValue: editData.po_wo_id },
            ]"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="handleChangepowoPdtl"
            :disabled="true"
          >
            <a-select-option v-for="item in listPOWO" :key="item.id" :disabled="item.sisa<=0">
              <!-- {{ item.item }} -->
              <div class="elipsdiv">
                <div class="elipsdiv-mouseover-label1" >
                  <template v-if="item.type_tax">
                    <b>[{{ lblTax(item.type_tax) }}]</b>
                  </template>
                  {{ item.item }}
                </div>
                <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">{{
                        formatCurrency(item.currency,parseFloat(item.sisa))
                      }}
                    </b>
                </div>
              </div>
            </a-select-option>
          </a-select>
          <div v-if="dtl_desc.unit_price!=''" class="m-form-description-small">
            <div class="m-display-flex space-between align-middle" slot="header">
              <span><b>Quantity : </b>{{dtl_desc.qty}}</span>
             <span><b>Unit Price : </b>{{formatCurrency(dtl_desc.currency,dtl_desc.unit_price)}}</span>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="Item Name">
          <a-input
            autocomplete="off"
            v-decorator="[
              'nama_item',
              {
                rules: [{ required: true }],
                initialValue: editData.nama_item,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="24" v-if="trigered.value.byQty">
          <a-col :span="getScreen ? 24 : 6">
            <a-form-item label="Quantity">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'quantity',
                  { rules: [{ required: true }, { validator: checkMaxValue }], initialValue: editData.quantity },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="getScreen ? 24 : 18">
            <a-form-item label="Unit">
              <a-auto-complete
                allowClear
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="[
                  'unit',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.unit,
                  },
                ]"
                :filterOption="handleSatuan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="trigered.value.byOption">
          <a-col :span="24">
            <a-form-item label="Value">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkMaxValue }], initialValue: editData.value },
                ]"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkPrice }], initialValue: editData.value },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Note">
          <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="[
              'note',
              { rules: [{ required: false }], initialValue: editData.note },
            ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleModalEdit(editData.key)"
            block
            type="danger"
            html-type="submit"
            v-decorator="['change']"
            ref="change"
            >Change</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
import nanoid from "nanoid";

export default {
  name: "Detail",
  mixins: [CurrencyFormat,GlobalMethod],
  props: {
    listData: {},
    informasi: {},
    mode: String,
    tax: String,
    mata_uang: String,
    shipping: Number,
    check_shipping: Boolean,
    id_pp: String,
    po_wo_dtl:{},
  },
  data() {
    return {
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      editModal: false,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      editData: [],
      push: [],
      newLoading: false,
      dataPN: [],
      selectedPN: null,
      selectedPNm: null,
      ppdetillist: [],
      selectedPPdtl: null,
      trigered: {
        tax: false,
        used_for: "0",
        percentage: false,
        Modalpercentage: false,
        disabledTaxBearer: false,
        ppdtl:false,
        powodtl:true,
        value:{
          byQty: true,
          byOption: false,
        },
        attachment: false,
      },
      formUsed:false,
      listPOWO: [],
      dtl_desc: {
        qty: "",
        unit_price:"",
        currency:"",
      },
      fileList:[],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
    this.formUpload = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth","getType_tax"]),
    totalPrice() {
      let total = 0;
      if (this.listData.length > 0) {
        let vdata = this.listData.filter((item) => "0" === item.used_for ||  "3" === item.used_for || "4" === item.used_for);
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            total += Number(item.value)*Number(item.quantity ? item.quantity : 1);
          });

        //menghitung jika tidak ada entri item namun entri pajak atau pph dll
        // let existitem = this.listData.filter((item) => "0" === item.used_for);
        // let existotheritem = this.listData.filter((item) => "0" != item.used_for);
        // if (existitem.length == 0 && existotheritem.length > 0) {
        //   if (existotheritem.length > 0)
        //     existotheritem.forEach((item) => {

        //       total += Number(item.value) * Number(item.quantity ? item.quantity : 1);
        //     });
        // }
      }

      return total;
    },
    totalPriceList() {
      let total = 0;

      if (this.listData.length > 0) {
        let vdata = this.listData.filter((item) => "0" === item.used_for);
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            total += Number(item.value)*Number(item.quantity ? item.quantity : 1);
          });
      }

      return total;
    },
    totalDiscList() {
      let total = 0;
      if (this.listData.length > 0) {
        let vdata = this.listData.filter((item) => "1" === item.used_for);
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            if (item.cur_type == "percentage") {
              total = total + (this.totalPrice * parseFloat(item.value)) / 100;
            } else {
              total = total + parseFloat(item.value);
            }
          });
      }

      return total;
    },
    totalShipping() {
      let shipping = 0;
      if (this.listData.length > 0) {
        let vdata = this.listData.filter(
          (item) => "3" === item.used_for || "4" === item.used_for
        );
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            if (item.cur_type == "percentage") {
              shipping =
                shipping + (this.totalPrice * parseFloat(item.value)) / 100;
            } else {
              shipping = shipping + parseFloat(item.value);
            }
          });
      }
      return shipping;
    },
    grandTotal() {
      return {
        all: this.totalPrice + this.nilaiPajak - this.totalDiscList,
        item: this.totalPrice
      };
    },
    // grandTotal() {
    //   let data = [...this.listData];
    //   let result  = {
    //     item: 0,
    //     all:0,
    //   };
    //   if (data) {
    //     data.forEach((value) => {
    //       result.item = !(value.type_tax && value.type_tax.includes("pph")) ? result.item+value.value : result.item;
    //       result.all = result.all + (((value.type_tax && value.type_tax.includes("pph")) ? -1 : 1)
    //         *Number(value.value*(value.quantity ? value.quantity : 1)));
    //     });
    //   }
    //   return result;
    // },
    nilaiPajak() {
      let tax = 0;
      if (this.listData.length > 0) {
        let vdata = this.listData.filter((item) => "2" === item.used_for);
        let isitemlist = this.listData.filter((item) => "0" === item.used_for);
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            if (isitemlist.length > 0 && (item.type_tax && item.type_tax.includes("pph"))) {
              tax = tax + 0;
            } else {
              tax = tax + parseFloat(item.value);
            }
          });
      }
      return tax;
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });

      return satuan;
    },
    getListTax() {
      let data = null;
      if (this.listData.length > 0)
        data = this.listData.filter((item) => "2" === item.used_for);
      return data;
    },
    getListDisc() {
      let data = null;
      if (this.listData.length > 0)
        data = this.listData.filter((item) => "1" === item.used_for);
      return data;
    },
    getListUsualShipp() {
      let data = null;
      if (this.listData.length > 0)
        data = this.listData.filter(
          (item) => "3" === item.used_for || "4" === item.used_for
        );
      return data;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          dataIndex: "nama_item",
          width: 250,
          scopedSlots: { customRender: "nama_item" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PO/WO Detail",
          width: 250,
          scopedSlots: { customRender: "itemPoWoDtl" },
          sorter: (a, b) => a.po_wo_nm.length - b.po_wo_nm.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          align: "center",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          title: "Unit",
          dataIndex: "unit",
          key: "unit",
          width: 100,
          sorter: (a, b) => a.unit.length - b.unit.length,
        },
        {
          title: "Values",
          align: "right",
          key: "hargaTotal",
          width: 150,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "Total Value",
          key: "amount",
          align: "right",
          width: 150,
          scopedSlots: { customRender: "amount" },
        },
        {
          title: "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 80,
          align: "center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      //let data = _.filter(this.listData,(item) => item.values.is_item == "yes");
      let data = [...this.listData];
      if (data) {
        data.forEach((value, index) => {
          data[index]["no"] = index + 1;
          if(value.type_tax && value.type_tax.includes("pph")){
            data[index]["key"] = "pphgrid" + (index + 1);
          }else{
            data[index]["key"] = "agrid" + (index + 1);
          }

          data[index]["nama_item"] = value.nama_item;

          let temp = _.filter(this.po_wo_dtl, (item)=> item.id_pp_dtl==value.pp_detail)
          data[index]["pp_nama_barang"] = temp.length>0 ? temp[0].nama_barang :null;
          data[index]["pp_kode_anggaran"] = temp.length>0 ? temp[0].kode_anggaran : null;

          data[index]["quantity"] = value.quantity;
          data[index]["value"] = value.value;
        });
      }
      return data;
    },
    anypph(){
      let data = [...this.listData];
      let result  = false;
      if (data) {
        data.forEach((value) => {
          if(value.type_tax && value.type_tax.includes("pph")){
            result=true;
          }
        });
      }
      return result;
    },
    listType_tax(){
      return _.filter(this.getType_tax,(item) => !item.value.includes('pph'));
      //return this.getType_tax;
    }
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("handleReplace", this.handleReplace);

    let result = this.initialCounting(this.po_wo_dtl,this.listData);
    Event.$emit("updatepowodtl", { value: result.ppdtl});
    this.listPOWO = _.filter(result.ppdtl, (item)=> item.kategori=="0");
  },
  activated(){
    let result = this.initialCounting(this.po_wo_dtl,this.listData);
    Event.$emit("updatepowodtl", { value: result.ppdtl});
    this.listPOWO = _.filter(result.ppdtl, (item)=> item.kategori=="0");
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("handleReplace", this.handleReplace);
  },
  methods: {
    moment,
    handleUseFor(val) {
      //console.log(val)
      this.form.resetFields();
      let vals = val.target.value;
      this.trigered.used_for = vals;
      this.dtl_desc = {
        qty: "",
        unit_price: "",
        currency: ""
      };
      if (vals=='2'){
        this.trigered.tax = true;
        this.trigered.attachment = true;
      }else{
        this.trigered.tax = false;
        this.trigered.attachment = false;
      }

      if(vals=='0'){
        this.trigered.value.byQty=true;
        this.trigered.value.byOption=true;
      }else{
        this.trigered.value.byQty=false;
        this.trigered.value.byOption=true;
      }

      if(vals=='1'){
        this.trigered.powodtl = false;
      }else{
        this.trigered.powodtl = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            po_wo_id: null,
          });
        });
      }

      vals = (!vals || vals=="1" ? "0": vals);
      if(vals=="2"){
        this.listPOWO = _.filter(this.po_wo_dtl, (item)=> item.kategori==vals && item.type_tax=='');
      }else{
        this.listPOWO = _.filter(this.po_wo_dtl, (item)=> item.kategori==vals);
      }

    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    preventEnterButtonModal() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.change.$children[0].$el.focus();
      });
    },
    handleOption(val) {
      if (val == "percentage") {
        this.trigered.percentage = true;
      } else {
        this.trigered.percentage = false;
      }
    },
    handleOptionModal(val) {
      if (val == "percentage") {
        this.trigered.Modalpercentage = true;
      } else {
        this.trigered.Modalpercentage = false;
      }
    },
    handleis_item(val) {
      if (val.target.value == "no") {
        this.trigered.is_item = "no";
        this.trigered.used_for = true;
        this.trigered.pn = false;
        this.trigered.cur = true;
        this.trigered.percentage = false;
        this.trigered.qty_unit = false;
      } else {
        this.trigered.is_item = "yes";
        this.trigered.used_for = false;
        this.trigered.pn = true;
        this.trigered.cur = false;
        this.trigered.percentage = false;
        this.trigered.qty_unit = true;
      }
    },
    handleRef() {
      if (this.listData.length <= 0) {
        this.displayMessage("form-moreData");
      } else {
        // Event.$emit("poData", { estimated_value: this.totalPrice });

        //regenerate ulang harga total untuk memutakhirkan percentage harga terakhir
        for (let index = 0; index < this.listData.length; index++) {
          if (this.listData[index].used_for == "0") {
            this.listData[index].valueTotal = this.listData[index].value;
          } else {
            if (this.listData[index].cur_type == "percentage") {
              if (this.listData[index].used_for == "1") {
                this.listData[index].valueTotal =
                  (this.totalPrice * parseFloat(this.listData[index].value)) /
                  100;
              } else {
                this.listData[index].valueTotal =
                  ((this.totalPrice - this.totalDiscList) *
                    parseFloat(this.listData[index].value)) /
                  100;
              }
            } else {
              this.listData[index].valueTotal = this.listData[index].value;
            }
          }
        }

        //jika default qty 0 dan value 0 tidak dirubah
        let tempdt = _.filter(this.listData,(item)=> item.quantity=="0" && item.value=="0");

        if (this.grandTotal <= 0) {
          this.displayMessageValue(
            "error-other",
            "Subtotal must be greater then 0!"
          );
        } else
        if (tempdt.length > 0) {
          this.displayMessageValue(
            "error-other",
            "The data still has qty and value 0!"
          );
        } else {
          Event.$emit("invData", {
            listData: this.listData,
            emptyValidator: this.listData.length,
            total: this.grandTotal.all,
          });
        }
      }
    },
    handleNewItem() {
      this.form.validateFields((err, values) => {
        console.log(values)
        if (err) {
          this.newLoading = false;
          this.displayMessage("form-warning");
          return;
        }

        if (values.used_for == "1") {
          if(values.value>(this.totalPrice-this.totalDiscList)){
            this.displayMessageValue(
            "error-other",
            "Discount must be lather then Subtotal value!"
          );
            return
          }
        }
        
        if (values.used_for == "0" && values.cur_type == "percentage") {
          this.newLoading = false;
          this.displayMessageValue(
            "error-other",
            "Subtotal cannot be filled with a percentage value!"
          );
          return;
        }
        if (values.used_for == "0" && values.value == 0) {
          this.newLoading = false;
          this.displayMessageValue(
            "error-other",
            "Subtotal cannot be 0 value!"
          );
          return;
        }

        if (values.quantity<=0) {
          this.newLoading = false;
          this.displayMessageValue(
            "error-other",
            "Quantity must be grather then 0!"
          );
          return;
        }

        if (values.value<=0) {
          this.displayMessageValue(
            "error-other",
            "Value must be grather then 0!"
          );
          return;
        }

        if(values.powopdtl){
          let exis = _.filter(this.listData,(item)=> item.po_wo_id == values.powopdtl);
          if(exis.length>0){
            this.newLoading = false;
            this.displayMessageValue(
              "error-other",
              "PO/WO Detil have been Used, data can only be edited!"
            );
            return;
          }
        }

        this.newLoading = true;
        let val = {...values};
        val.key = nanoid();

        let powodtl=[];
        if(values.powopdtl){
          powodtl = this.po_wo_dtl.filter((valu) => valu.id == values.powopdtl);
          val.po_wo_nm=powodtl[0].item;
        }
        //console.log("val",val)

        let isprocess = true;
        if (this.listData.length > 0) {
          let newdata = this.listData.filter((valu) => valu.used_for == "0" && valu.nama_item.toLowerCase()==values.nama_item.toLowerCase());
          if (newdata.length == 1 && val.used_for == "0") {
            this.confirmMessageValue("confirm-replace", val);
            isprocess = false;
            //this.newLoading = false;
            //return
          }
        } else {
          if (values.used_for !== "0") {
            isprocess = false;
            this.displayMessageValue(
              "error-other",
              "Subtotal must be filled in first!"
            );
            this.newLoading = false;
            return;
          }
        }

        if (isprocess) {
          let tp = [];
          for (let i = 0; i < this.listData.length; i++) {
            tp.push({...this.listData[i]});
          }
          
          let dt = {
            used_for: val.used_for,
            po_wo_id: val.powopdtl,
            nama_item: val.nama_item,
            quantity : val.quantity,
            po_wo_nm: val.po_wo_nm,
            value: val.value,
            type_tax: powodtl.length>0 ? powodtl[0].type_tax : null,
            note: val.note,
            unit: val.unit,
            attachment: this.fileList.length>0 ? this.fileList[0] : null,
          };
          tp.push(dt);
          let dd = [];
          this.po_wo_dtl.forEach((item) => {
            dd.push(item);
          });
          let result = this.initialCounting(dd,tp);
          if(result.valid){
            Event.$emit("updatepowodtl", { value: result.ppdtl});
            Event.$emit("updateList", { value: tp, type: "delete" });
            this.resetForm(result.ppdtl);
            this.newLoading = false;
           }else if(result.grandtotalminus){
            this.displayMessageValue(
              "basic-error",
              "Sub total result can't be minus!"
            );
            this.newLoading = false;
            return;
          }else if(!result.valid){
            this.displayMessageValue(
              "basic-error",
              "The value is grather then Budget PO/WO Detail!"
            );
            this.newLoading = false;
            return;
          }
        }
      });
    },
    handleReplace(val) {
      //console.log("handleReplace",val)
      let newdata = this.listData.filter(
        (valu) => valu.used_for !== val.used_for
      );
      newdata.push(val);
      Event.$emit("updateList", { value: newdata, type: "delete" });
      this.resetForm();
      this.newLoading = false;
    },
    handleRemove(item) {
      //console.log(item)
      this.confirmMessageValue("confirm-delete", item, null);
    },
    delete(val) {
      const newPush = this.listData.filter((item) => item.key !== val.key);

      // let mintrans = _.filter(newPush, (el) => el.used_for=="0" && el.key !== val.key);
      // let othertrans = _.filter(newPush, (el) => el.used_for!="0" && el.key !== val.key);
      // if(othertrans.length>0 && mintrans.length==0){
      //   this.displayMessageValue(
      //     "basic-error",
      //     "There must be at least one transaction of type use for 'Item Subtotal'!"
      //   );
      //   return;
      // }

      let dd = [];
      this.po_wo_dtl.forEach((item) => {
        dd.push(item);
      });
      let result = this.initialCounting(dd,newPush);
      if(result.valid){
        Event.$emit("updateList", { value: newPush, type: "delete" });
        Event.$emit("updatepowodtl", { value: result.ppdtl});
        this.modalForm.resetFields();
        this.resetForm(result.ppdtl);
      }else if(!result.valid){
        this.displayMessageValue(
          "basic-error",
          "The value is grather then Budget PO/WO Detail!"
        );
        return;
      }else if(result.grandtotalminus){
        this.displayMessageValue(
          "basic-error",
          "The value can't exceed the grand total value!"
        );
        return;
      }
    },
    handleEditModal(item) {
      this.modalForm.resetFields();
      this.editData = item;
      this.editModal = !this.editModal;
      this.trigered.disc = item.used_for == "0" ? true : false;
    },
    handleEditModalSubtotal() {
      this.modalForm.resetFields();
      let val = this.listData.filter((item) => item.used_for == "0");
      this.editData = val[0];
      this.editModal = !this.editModal;
      this.trigered.disc = this.editData.used_for == "0" ? true : false;
    },
    handleClose() {
      this.resetForm();
      if(this.editData.po_wo_id){
        let ppdtl = [];      
        for (let t = 0; t < this.po_wo_dtl.length; t++) {
          ppdtl.push({...this.po_wo_dtl[t]});
        }
        let po_wo_id = this.editData.po_wo_id;
        let index = _.findIndex(ppdtl, (e) => {return e.id == po_wo_id;}, 0); 
        ppdtl[index].sisa = this.editData.powovalue_before;
        Event.$emit("updatepowodtl", { value: ppdtl});

        this.listPOWO = _.filter(ppdtl, (item)=> item.kategori=="0"); //reset ke tampilan awal
        
      }
    },
    resetForm(po_wo_dtl) {
      this.form.resetFields();
      this.fileList = [];
      this.trigered.used_for = "0";
      this.trigered.percentage = false;
      this.trigered.value.byQty = true;
      this.trigered.value.byOption = true;
      this.trigered.powodtl = true;
      this.trigered.attachment = false;
      this.trigered.tax = false;

      this.dtl_desc.unit_price = "";
      this.dtl_desc.qty = "";
      this.dtl_desc.currency = "";

      if(po_wo_dtl!=null){
        this.listPOWO = _.filter(po_wo_dtl, (item)=> item.kategori=="0");
      }else{
        this.listPOWO = _.filter(this.po_wo_dtl, (item)=> item.kategori=="0");
      }
    },
    handleModalEdit(id_key) {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (values.used_for == "1") {
          if(values.value>(this.totalPrice+this.editData.value-this.totalDiscList)){
            this.displayMessageValue(
            "error-other",
            "Discount must be lather then Subtotal value!"
          );
            return
          }
        }

        if (values.quantity<=0) {
          this.displayMessageValue(
            "error-other",
            "Quantity must be grather then 0!"
          );
          return;
        }

        if (values.value<=0) {
          this.displayMessageValue(
            "error-other",
            "Value must be grather then 0!"
          );
          return;
        }

        let findNames = null;
        findNames = _.filter(
          this.listData,
          (obj) =>
            obj.used_for &&
            obj.used_for.toLowerCase() == values.used_for.toLowerCase() &&
            obj.nama_item &&
            obj.nama_item.toLowerCase() == values.nama_item.toLowerCase()
        );

        if (findNames.length > 0 && findNames[0].key !== id_key) {
          this.displayMessage("form-duplicate");
          return;
        } else {
          //validasi value entri
          //let vmsk = values.value;

          //let dataExist = {};

          //get discount exist
          // dataExist = _.filter(
          //   this.listData,
          //   (obj) =>
          //     obj.key &&
          //     obj.key.toLowerCase() == id_key.toLowerCase() &&
          //     obj.used_for == "1"
          // );

          // let discExist = 0;
          // if (dataExist.length > 0) {
          //   discExist = dataExist[0].value;
          // }

          //validasi pajak : tidak boleh lebih dari total
          // console.log(values.used_for, vmsk , this.totalPrice)
          // if (values.used_for == "2" && vmsk > this.totalPrice) {
          //   this.newLoading = false;
          //   this.displayMessage("grather-remaining");
          //   return;
          // }
          //validasi discount : tidak boleh lebih dari total
          // if (
          //   values.used_for == "1" &&
          //   vmsk > this.totalPrice - (this.totalDiscList - discExist)
          // ) {
          //   this.newLoading = false;
          //   this.displayMessage("grather-remaining");
          //   return;
          // }

          // const newPush = this.listData.filter((item) => item.key !== id_key);

          // let hargaTotal = 0;
          // let valh = values.value;
          // if (values.used_for == "2") {
          //   hargaTotal =
          //     values.cur_type == "percentage"
          //       ? (valh *
          //           (this.totalPrice
          //             ? this.totalPrice - this.totalDiscList
          //             : 0)) /
          //         100
          //       : valh;
          // } else {
          //   hargaTotal =
          //     values.cur_type == "percentage"
          //       ? (valh * (this.totalPrice ? this.totalPrice : 0)) / 100
          //       : valh;
          // }

          // values.valueTotal = hargaTotal;
          // values.nama_item = values.nama_item ? values.nama_item : null;
          // values.key = nanoid();

          // newPush.push(values);

          //let powodtl=[];
          //if(values.powopdtl){
          //  powodtl = this.po_wo_dtl.filter((valu) => valu.id == values.powopdtl);
          //}

          let tp = [];
          for (let i = 0; i < this.listData.length; i++) {
            tp.push({...this.listData[i]});
          }
          let indx = _.findIndex(tp, {key: id_key});
          tp[indx].value = values.value;
          tp[indx].nama_item= values.nama_item,
          tp[indx].unit= values.unit,
          tp[indx].quantity= values.quantity,
          //tp[indx].po_wo_nm= values.po_wo_nm,
          //tp[indx].type_tax= powodtl.length>0 ? powodtl[0].type_tax : null,
          tp[indx].note= values.note;
          if(this.fileList.length>0){
            tp[indx].attachment = this.fileList[0];
          }else{
            tp[indx].attachment = undefined;
          }

          let dd = [];
          this.po_wo_dtl.forEach((item) => {
            dd.push(item);
          });
          let result = this.initialCounting(dd,tp);

          if(result.valid){
            Event.$emit("updatepowodtl", { value: result.ppdtl});
            Event.$emit("updateList", { value: tp, type: "delete" });
            this.editModal = !this.editModal;
            this.resetForm();
            this.displayMessageValue(
              "update-item",
              values.nama_item ? values.nama_item : "Subtotal"
            );
            this.listPOWO = _.filter(result.ppdtl, (item)=> item.kategori=="0"); //reset ke tampilan awal
          }else if(!result.valid){
            this.displayMessageValue(
              "basic-error",
              "The value is grather then Budget PO/WO Detail!"
            );
            return;
          }else if(result.grandtotalminus){
            this.displayMessageValue(
              "basic-error",
              "The value cann't exceed the grand total value!"
            );
            return;
          }
        }
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Value must greater than zero!");
    },
    checkMaxValue(rule, value, callback) {
      if (value <= 9999999999999) {
        callback();
        return;
      }
      callback("Max. value 9.999.999.999.999!");
    },
    changeTaxBearer(val){
        if(val.target.value=='0'){
          this.trigered.enablePPTaxBearer=true;
          this.trigered.dis_tax_type = true;
        }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlepowodtl(){

    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
      }
    },
    handleToDelete(val){
    const newPush = this.listData.filter((item) => item.key !== val.key);

    let mintrans = _.filter(newPush, (el) => el.used_for=="0" && el.key !== val.key);
      let othertrans = _.filter(newPush, (el) => el.used_for!="0" && el.key !== val.key);
      if(othertrans.length>0 && mintrans.length==0){
        this.displayMessageValue(
          "basic-error",
          "There must be at least one transaction of type use for 'Item Subtotal'!"
        );
        return;
      }

      let dd = [];
      this.po_wo_dtl.forEach((item) => {
        dd.push(item);
      });
      let result = this.initialCounting(dd,newPush);
      if(result.valid){
        Event.$emit("updateList", { value: newPush, type: "delete" });
        Event.$emit("updatepowodtl", { value: result.ppdtl});
        this.modalForm.resetFields();
        this.resetForm(result.ppdtl);
      }else if(!result.valid){
        this.displayMessageValue(
          "basic-error",
          "The value is grather then Budget PO/WO Detail!"
        );
        return;
      }else if(result.grandtotalminus){
        this.displayMessageValue(
          "basic-error",
          "The value cann't exceed the grand total value!"
        );
        return;
      }
    },
    initialCounting(lsdtl,listPurchasing){
      let ppdtl = [];      
      for (let t = 0; t < lsdtl.length; t++) {
        ppdtl.push({...lsdtl[t]});
      }

      //listPurchasing.sort((a, b) => (a.id ? a.id :"z9").localeCompare(b.id ? b.id :"z9"));

      //reset nilai ppdtl sesuai nilai origin
      for (let b = 0; b < ppdtl.length; b++) {
        ppdtl[b].sisa = Number(ppdtl[b].sisa_ori);
      }

      let valid = true;
      let grandtotalminus = false;
      for (let i = 0; i < listPurchasing.length; i++) {
          let index = _.findIndex(ppdtl, {id: listPurchasing[i].po_wo_id});
          if(index>=0){
            let values = Number(listPurchasing[i].value)*Number(listPurchasing[i].quantity ? listPurchasing[i].quantity : 1);
            let hsl = (Number(ppdtl[index].sisa)-values);
            ppdtl[index].sisa = hsl;
          }else if(listPurchasing[i].used_for=='1'){
            let totalitem = 0;
            for (let q= 0; q < listPurchasing.length; q++) {
              if(listPurchasing[q].po_wo_id!=undefined){
                totalitem += listPurchasing[q].value*(listPurchasing[q].quantity ? listPurchasing[q].quantity : 1);
              }
            }
            //discount proportional
            for (let w = 0; w < listPurchasing.length; w++) {
              if(listPurchasing[w].used_for=="0"){
                let ind2 = _.findIndex(ppdtl, {id: listPurchasing[w].po_wo_id});
                ppdtl[ind2].sisa = ppdtl[ind2].sisa + 
                  (((listPurchasing[w].value*(listPurchasing[w].quantity ? listPurchasing[w].quantity : 1))/totalitem)*listPurchasing[i].value);
              }
            }
        }
      }
      //cek ppdtl apakah ada yang minus
      for (let q = 0; q < ppdtl.length; q++) {
        if(ppdtl[q].sisa<0)
          valid = false;
      }

      let ttl = 0;
      let isexistitem = _.filter(listPurchasing, (item) => item.used_for == "0")
      for (let c = 0; c < listPurchasing.length; c++) {
        if (listPurchasing[c].used_for=='0' || listPurchasing[c].used_for=='3' || listPurchasing[c].used_for=='4'){
          ttl += Number(listPurchasing[c].value)*(listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
        }else if(listPurchasing[c].used_for=='2' && listPurchasing[c].type_tax!=undefined && listPurchasing[c].type_tax!=null
          && !listPurchasing[c].type_tax.includes('pph')){
            ttl += Number(listPurchasing[c].value)*(listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
        } else {
          if (isexistitem.length==0) {
            ttl += Number(listPurchasing[c].value) * (listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
          } else {
            ttl -= Number(listPurchasing[c].value) * (listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
          }
        }
      }

      if(ttl<0){
        grandtotalminus = true;
        valid = false;
      }

      return {valid,ppdtl,grandtotalminus};
    },
    lblTax(val){
      let result = _.filter(this.getType_tax,(item)=>item.value==val);
      return (result.length>0 ? result[0].text : "");
    },
    handleChangepowoPdtl(val){
      let result = _.filter(this.po_wo_dtl,(item)=>item.id==val);
      if(result.length>0){
        this.dtl_desc.unit_price = result[0].unit_price;
        this.dtl_desc.qty = result[0].qty;
        this.dtl_desc.currency = result[0].currency;

      }else{
        this.dtl_desc.unit_price = "";
        this.dtl_desc.qty = "";
        this.dtl_desc.currency = "";
      }
    },
    handleToEdit(item){

      this.editData = item;
      this.handleChangepowoPdtl(item.po_wo_id);
      this.editModal = !this.editModal;

      let ppdtl = []; 
      if(item.po_wo_id){     
        for (let t = 0; t < this.po_wo_dtl.length; t++) {
          ppdtl.push({...this.po_wo_dtl[t]});
        }
        let index = _.findIndex(ppdtl, (e) => {return e.id == item.po_wo_id;}, 0); 
        this.editData.powovalue_before = ppdtl[index].sisa;
        ppdtl[index].sisa = Number(ppdtl[index].sisa) + (Number(item.value)*(item.quantity ? item.quantity : 1));
        Event.$emit("updatepowodtl", { value: ppdtl});
      }

      let usdval = {target:{value:item.used_for}};
      this.handleUseFor(usdval);
      if(item.po_wo_id)
        this.handleChangepowoPdtl(item.po_wo_id);
      if(item.po_wo_id){
        let vals = (!item.used_for || item.used_for=="0" ? "0": item.used_for );
        this.listPOWO = _.filter(ppdtl, (item)=> item.kategori==vals);
      }

      if(item.attachment){
        this.trigered.attachment = true;
        this.fileList.push(item.attachment);
        this.$nextTick(function () {
          this.modalForm.setFieldsValue({
            attachment: item.attachment,
          });
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    handleRemoveList() {
      this.fileList = [];
    },
    handleToPreview(val){
      let blob = new Blob([val.attachment], { type: val.attachment.type }),
        url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    lblusedfor(val){
      if(val=="0"){
        return "Item";
      }else if(val=="2"){
        return "Tax";
      }else if(val=="3"){
        return "Shipping";
      }else if(val=="4"){
        return "Etc";
      }else if(val=="1"){
        return "Discount";
      }else{
        return "";
      }
    },
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    taxTypeChange(vals){
        this.listPOWO = _.filter(this.po_wo_dtl, (item)=> item.type_tax==vals && item.kategori=='2');
    },
  },
};
</script>

<style lang="less" scoped>
.m-price-total {
  &_dtl {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;

    li {
      display: flex;
      flex-direction: column;
      padding-bottom: @padding / 2;
      border-bottom: 1px solid darken(white, 10);

      h4 {
        text-transform: capitalize;
      }
    }

    &__value {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>

<style lang="less">
.footer-list {
  display: flex;
  justify-content: flex-end;
  .ant-row {
    width: 100%;
  }
}
.footer-light {
  font-size: medium;
}
.divnone {
  display: none;
}
.divblock {
  display: block;
}
</style>
